import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { muiTheme } from 'app/themes/materialUi';
import { Grid, Box, Typography } from '@mic3/platform-ui';
import { toUniqueUUID } from 'app/utils/string/string-utils';
import ArrowBack from 'app/components/organisms/AppHeader/ArrowBack'

const BarBox = styled(Grid)`
    margin: 0px 8px;
    padding: 0px 8px;
    ${({ withoutdivider, theme }) => !withoutdivider && `border-bottom: 1px solid ${theme.material.colors.background.divider};`}
    grid-area: pActions;
     ${({ isMobile }) => !isMobile && `min-height: 49px;`}
    display: flex;
     flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
    & .MuiIconButton-root {
        max-height: 48px;
    }
`;

const getFlexDirection = ({ isMobile, isForward, rowDirection, isSidebar }) => {
    if (!isMobile || rowDirection || isSidebar) return 'row';
    return isForward ? 'column' : 'column-reverse';
};

const Bar = styled(Grid)`
    display: flex;
    min-height: 45px;
    flex-direction: ${getFlexDirection};
    justify-content: space-between;
    color: ${({ theme }) => theme.color.white};
`;


const StyledBox = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items:center;
    .MuiDivider-vertical {
        height: 40px;
    }
`;

const GridItem = styled(Grid)`
    display: flex;
    align-items: center;
    & > * {
        margin: 4px;
    }
`;

const GridItemLeft = styled(GridItem)`
    flex-grow: 1;
    max-width: 100%;
`;

const HeaderBar = ({ withoutDivider, leftStyles, left, right, wrap, bottom, className, isForward, rowDirection, id, ...props }) => {
    const isMobile = useSelector(state => state.global.isMobile);
    const isSidebar = useSelector(state => state.sidebar.isOpen);
    return (
        <BarBox isMobile={isMobile} withoutdivider={withoutDivider ? 1 : 0} className={className} >
            <Bar container wrap={wrap} isMobile={isMobile} isForward={isForward} rowDirection={rowDirection} isSidebar={isSidebar}>
                <GridItemLeft item style={leftStyles}>
                    {left}
                </GridItemLeft>
                {isMobile ?
                    <StyledBox>
                        <ArrowBack left={left} />
                        <GridItem item>{right}</GridItem>
                    </StyledBox>
                    :
                    <GridItem item>{right}</GridItem>
                }
            </Bar>
            {id && !isSidebar && isMobile && (
                <Typography style={{ color: muiTheme.colors.text.caption, fontSize: '12px', fontWeight: 400, letterSpacing: 0.4 }}>
                    {`#${toUniqueUUID(id)}`}
                </Typography>)
            }
            {bottom}
        </BarBox>
    );
};

export default HeaderBar;
